import React, { useState, useEffect } from 'react';
import { useCountdown } from '../../../context/useCountdown';
import DayLeftToolTip from '../../../components/Shared/tooltip/dayleft';
import { CheckOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { Button, Form, Input, TreeSelect, Tag, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import DataFlowService from '../../../services/DataFlow.service';
import { CloseOutlined, ExportOutlined } from '@ant-design/icons';
import ModalConfirm from '../../../components/Shared/modal/confirm';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import MyTaskService from '../../../services/MyTask.service';
import useNotify from '../../../context/Notification/useNotify';
import usePermission from '../../../hooks/usePermission';

const { Option } = Select;

export default function TaskDetail({
    setVisibleHistories,
    setIsChangeStatus,
    detail,
    setConfirmMode,
    setValues,
    setActionMode,
    isAccept,
    setIsAccept,
    state,
    setNotes,
    setSelectedValues,
    selectedValues,
    setCancelDetail,
    cancelDetail,
    getMyTaskDetail,
    setRemindDetail,
    userApprover,
}) {
    const [form] = Form.useForm();
    const { TextArea } = Input;
    const { t, i18n } = useTranslation();
    const notify = useNotify();
    let lang = i18n.language;
    let { tab, dsrTaskId } = useParams();

    const [departmentList, setDepartmentList] = useState([]);

    const [openConfirm, setOpenConfirm] = useState(false);
    // const [openAccept, setOpenAccept] = useState(false);
    const [openConfirmAcknowledge, setOpenConfirmAcknowledge] = useState(false);
    const [loading] = useState(false);
    const [requestStatus, setRequestStatus] = useState(detail?.statusNameEn);

    const _getTagOperationStatus = (e) => {
        switch (e) {
            case 'Doing':
                return {
                    color: '#F9C153',
                };
            case 'Task Done':
                return {
                    color: '#4ACE8F',
                };
            case 'Task Canceled':
                return {
                    color: '#F0536F',
                };
            case 'Task Canceling':
                return {
                    color: '#65707A',
                };
            case 'To Do':
                return {
                    color: '#1890FF',
                };
            default:
                return { color: '#FFF' };
        }
    };

    const onFinish = async (value) => {
        checkWorkFlow();
        setValues(value);
        // setConfirmMode(true)
    };

    useEffect(() => {
        const getDepartment = async () => {
            try {
                let lang = i18n.language;
                const { data } = await DataFlowService.getAllDepartmentList();
                if (data?.resultData) {
                    let option = [];
                    data?.resultData?.forEach((element) => {
                        option.push({
                            title:
                                lang === 'en' ? element.nameEn : element.nameTh,
                            value: element.departmentId,
                        });
                    });
                    setDepartmentList(option);
                }
            } catch (err) {
                console.log(err);
            }
        };
        setSelectedValues([]);
        getDepartment();
        setRequestStatus(detail?.statusNameEn);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state, detail]);

    const onChange = (e) => {
        setNotes(e.target.value);
        // console.log(e.target.value);
    };

    const checkWorkFlow = async () => {
        try {
            const { data } = await MyTaskService.checkStatusWorkflow(
                detail?.workflowId
            );
            // console.log('data ',data)
            if (data?.resultData) {
                // console.log('go to preview....')
                if (data?.resultData?.workFlowIsActive === false) {
                    notify({
                        type: 'error',
                        title: t('MyTask.WorkflowIsDisabled'),
                        description: t('MyTask.PleaseContactAdmin', {
                            emailOwnerAccount:
                                data?.resultData?.emailOwnerAccount,
                        }),
                        timeOut: 120000,
                        closeable: true,
                    });
                } else {
                    setConfirmMode(true);
                }
            }
        } catch (err) {
            console.log(err);
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('common.Fail'),
                timeOut: 120000,
                closeable: true,
            });
        }
    };

    const accectMyTask = async () => {
        try {
            const { data } = await MyTaskService.accectMyTask({
                dsrTaskId: dsrTaskId,
            });
            if (data?.resultCode === 1) {
                setOpenConfirm(false);
                notify({
                    title: t('common.Success'),
                    description: t('Successfully to Accepted data'),
                    timeOut: 1000,
                });
                getMyTaskDetail();
                // console.log('call service detail....')
            } else {
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to Accepted data'),
                    timeOut: 120000,
                    closeable: true,
                });
            }
        } catch (err) {
            console.log(err);
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('common.FailedSaveData'),
                timeOut: 120000,
                closeable: true,
            });
        }
    };

    const confirmAcknowledge = async () => {
        // console.log('call service ... ', cancelDetail)
        // console.log(detail?.operationTask);
        const operation = [];
        detail?.operationTask?.forEach((e) => {
            operation.push({
                taskStatusName: e?.statusNameEn,
                departmentName: e?.departmentList[0]?.departmentNameEn,
                operationPersonName: e?.assigneeNameEn || '-',
            });
        });
        const payload = {
            requestId: detail?.requestId, //คำขอใช้สิทธิ
            operationTaskId: cancelDetail?.operationTaskId, //operationTask ของ record ที่กด acknowledge
            approverName: userApprover?.approverName, // เอามาจาก user profile
            departmentName: userApprover?.departmentName, //operationTask ของ record ที่กด acknowledge
            operationTasks: operation || [],
        };
        try {
            const { data } = await MyTaskService.confirmAcknowledge(payload);
            if (data?.resultCode === 1) {
                setOpenConfirmAcknowledge(false);
                notify({
                    title: t('common.Success'),
                    description: t('Successfully to completed data'),
                    timeOut: 1000,
                });
                getMyTaskDetail();
                form.resetFields();
                // navigate(`${ROUTER.DS_360.MY_TASK}/request-done/${dsrTaskId}`);
            } else {
                setOpenConfirmAcknowledge(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to completed data'),
                    timeOut: 120000,
                    closeable: true,
                });
            }
        } catch (err) {
            console.log(err);
            setOpenConfirmAcknowledge(false);
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to completed data'),
                timeOut: 120000,
                closeable: true,
            });
        }
    };

    const onChangeDepartment = (value) => {
        setSelectedValues([value]);
        form.setFieldsValue({ organizeDataCollection: [value] });
    };

    const { isAuditor } = usePermission();

    return (
        <>
            <div className="flex pt-4">
                <DayLeftToolTip />
            </div>
            <Form form={form} layout="vertical" onFinish={onFinish}>
                <div className="col-span-1 bg-white h-max rounded-xl p-4 py-4 my-4">
                    <div className="flex justify-between items-center">
                        <div className="text-[20px] font-semibold">
                            {tab !== 'operation-done' &&
                                tab !== 'request-done' &&
                                tab !== 'cancel-task' &&
                                (lang === 'en'
                                    ? detail?.workflowStepNameEn || '-'
                                    : detail?.workflowStepNameTh || '-')}

                            {tab === 'operation-done' && 'Operation Done'}
                            {tab === 'request-done' && 'Request Done'}
                            {tab === 'cancel-task' &&
                                (lang === 'en'
                                    ? detail?.workflowStepCancelNameEn || '-'
                                    : detail?.workflowStepCancelNameTh || '-')}
                        </div>
                        <button
                            onClick={(e) => {
                                e.preventDefault();
                                setIsChangeStatus(true);
                                setVisibleHistories(true);
                            }}
                            className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-sm"
                        >
                            <ClockCircleOutlined />
                        </button>
                    </div>
                    <div className="py-2">
                        {tab === 'cancel-task' && (
                            <>
                                {lang === 'en'
                                    ? detail?.workflowStepCancelDescriptionEn ||
                                      '-'
                                    : detail?.workflowStepCancelDescriptionTh ||
                                      '-'}
                            </>
                        )}
                        {(tab === 'todolist' || tab === 'follow-up') && (
                            <>
                                {lang === 'en'
                                    ? detail?.workflowStepDescriptionEn || '-'
                                    : detail?.workflowStepDescriptionTh || '-'}
                            </>
                        )}
                        {(tab === 'request-done' ||
                            tab === 'operation-done') && (
                            <>
                                {detail?.requestId ? (
                                    <>
                                        {t('MyTask.RequestDoneDetailHeader', {
                                            requestID: detail?.requestId,
                                        })}
                                    </>
                                ) : (
                                    '-'
                                )}
                            </>
                        )}
                    </div>
                    {tab === 'request-done' ? (
                        <button
                            className="text-sm font-semibold text-[#1890FF] cursor-pointer underline hover:opacity-80 hover:text-[#1890FF] hover:underline"
                            onClick={(e) => {
                                e.preventDefault();
                                setIsChangeStatus(true);
                                setVisibleHistories(true);
                            }}
                        >
                            {t('MyTask.ReadNotes')}
                        </button>
                    ) : (
                        <></>
                    )}

                    {state &&
                        state !== 'Verification' &&
                        tab !== 'request-done' && (
                            <button
                                className="text-sm font-semibold text-[#1890FF] cursor-pointer underline hover:opacity-80 hover:text-[#1890FF] hover:underline"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setIsChangeStatus(true);
                                    setVisibleHistories(true);
                                }}
                            >
                                {t('MyTask.ReadNotes')}
                            </button>
                        )}

                    {/* todolist */}
                    {/* todolist */}
                    {/* todolist */}
                    {/* todolist */}
                    {/* todolist */}
                    {/* todolist */}
                    {/* todolist */}
                    {tab === 'todolist' && (
                        <>
                            {state === 'Verification' ||
                            state === 'Assign Task' ||
                            state === 'Cancel Task' ||
                            (state === 'Other Task' && isAccept === true) ||
                            (state === 'Complete Task' && isAccept === true) ? (
                                <Form.Item
                                    className="mt-2"
                                    label={
                                        <label className="font-semibold">
                                            {t('Notes')}
                                        </label>
                                    }
                                    name={'notes'}
                                >
                                    <TextArea
                                        disabled={isAuditor}
                                        size="large"
                                        className="bg-[#F4F6FC]"
                                        autoSize={{ minRows: 3, maxRows: 4 }}
                                        showCount
                                        maxLength={200}
                                        placeholder={t(
                                            'MyTask.DescribeDetails'
                                        )}
                                        onChange={onChange}
                                    />
                                </Form.Item>
                            ) : (
                                <></>
                            )}
                            <div
                                className="my-4"
                                style={{ borderBottom: '1px solid #ECECEC' }}
                            ></div>

                            {state === 'Verification' ||
                            state === 'Assign Task' ||
                            (state === 'Other Task' && isAccept === true) ? (
                                <div className="grid grid-cols-6 gap-4">
                                    <div className="col-span-5">
                                        <Form.Item
                                            className="mb-2 w-full"
                                            name={'organizeDataCollection'}
                                            label={
                                                <>
                                                    <span className="text-[14px] font-semibold">
                                                        {t(
                                                            'MyTask.AssignMyTask'
                                                        )}
                                                    </span>
                                                    <span className="text-[14px] font-semibold text-[#7B67FB] ml-1">
                                                        {lang === 'en'
                                                            ? `"${detail?.workflowNextStepNameEn}"`
                                                            : `"${detail?.workflowNextStepNameTh}"`}
                                                    </span>
                                                </>
                                            }
                                            rules={[
                                                {
                                                    required: true,
                                                    message: t(
                                                        'errorText.requiredField'
                                                    ),
                                                },
                                            ]}
                                        >
                                            {/* Assign */}
                                            {/* Assign */}
                                            {/* Assign */}
                                            {/* Assign */}
                                            {/* Assign */}
                                            {/* Assign */}
                                            {/* Assign */}
                                            {/* Assign */}

                                            {detail?.workflowNextStepNameEn.toLowerCase() ===
                                            'other task' ? (
                                                <Select
                                                    disabled={
                                                        !detail?.isProcessing
                                                    }
                                                    className="w-full"
                                                    size="large"
                                                    style={{
                                                        textAlign: 'left',
                                                    }}
                                                    placeholder={t(
                                                        'MyTask.ChooseDepartment'
                                                    )}
                                                    onChange={
                                                        onChangeDepartment
                                                    }
                                                    showSearch
                                                    optionFilterProp="children"
                                                    filterOption={(
                                                        input,
                                                        option
                                                    ) =>
                                                        (option?.children ?? '')
                                                            .toLowerCase()
                                                            .includes(
                                                                input.toLowerCase()
                                                            )
                                                    }
                                                >
                                                    {departmentList?.map(
                                                        (e) => (
                                                            <Option
                                                                size="large"
                                                                key={e.value}
                                                                value={e.value}
                                                            >
                                                                {e.title}
                                                            </Option>
                                                        )
                                                    )}
                                                </Select>
                                            ) : (
                                                <TreeSelect
                                                    treeCheckable
                                                    size="large"
                                                    placeholder={t(
                                                        'MyTask.ChooseDepartment'
                                                    )}
                                                    disabled={
                                                        isAuditor ||
                                                        !detail?.isProcessing
                                                    }
                                                    filterTreeNode={(
                                                        search,
                                                        item
                                                    ) => {
                                                        return (
                                                            String(item?.title)
                                                                ?.toLowerCase()
                                                                ?.indexOf(
                                                                    search?.toLowerCase()
                                                                ) >= 0
                                                        );
                                                    }}
                                                    showCheckedStrategy={
                                                        TreeSelect.SHOW_CHILD
                                                    }
                                                    dropdownStyle={{
                                                        maxHeight: '300px',
                                                    }}
                                                    onChange={(ids) =>
                                                        setSelectedValues(ids)
                                                    }
                                                    showArrow
                                                    treeData={[
                                                        {
                                                            title:
                                                                selectedValues.length ===
                                                                departmentList?.length ? (
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => {
                                                                            setSelectedValues(
                                                                                []
                                                                            );
                                                                            form.setFieldsValue(
                                                                                {
                                                                                    organizeDataCollection:
                                                                                        [],
                                                                                }
                                                                            );
                                                                        }}
                                                                        style={{
                                                                            display:
                                                                                'inline-block',
                                                                            color: '#286FBE',
                                                                            cursor: 'pointer',
                                                                        }}
                                                                    >
                                                                        {t(
                                                                            'dataFlow.UnselectAll'
                                                                        )}
                                                                    </button>
                                                                ) : (
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => {
                                                                            setSelectedValues(
                                                                                departmentList.map(
                                                                                    (
                                                                                        e
                                                                                    ) =>
                                                                                        e.value
                                                                                )
                                                                            );
                                                                            form.setFieldsValue(
                                                                                {
                                                                                    organizeDataCollection:
                                                                                        departmentList.map(
                                                                                            (
                                                                                                e
                                                                                            ) =>
                                                                                                e.value
                                                                                        ),
                                                                                }
                                                                            );
                                                                        }}
                                                                        style={{
                                                                            display:
                                                                                'inline-block',
                                                                            color: '#286FBE',
                                                                            cursor: 'pointer',
                                                                        }}
                                                                    >
                                                                        {t(
                                                                            'RoPA.SelectAll'
                                                                        )}
                                                                    </button>
                                                                ),
                                                            value: 'xxx',
                                                            disableCheckbox: true,
                                                            disabled: true,
                                                            checkable: false,
                                                        },
                                                        ...departmentList,
                                                    ]}
                                                />
                                            )}
                                        </Form.Item>
                                    </div>
                                    <div className="col-span-1 mt-9">
                                        <Button
                                            className="w-full"
                                            htmlType="submit"
                                            size="large"
                                            type="primary"
                                            disabled={
                                                isAuditor ||
                                                !detail?.isProcessing
                                            }
                                            // disabled={selectedValues <= 0}
                                            onClick={() =>
                                                setActionMode('Confirm')
                                            }
                                        >
                                            {t('common.Confirm')}
                                        </Button>
                                    </div>
                                </div>
                            ) : (
                                <></>
                            )}

                            {(state === 'Other Task' ||
                                state === 'Complete Task') &&
                            (!isAccept || isAccept === false) ? (
                                <div className="text-right justify-end">
                                    <Button
                                        disabled={isAuditor}
                                        className="w-40"
                                        // htmlType="submit"
                                        size="large"
                                        type="primary"
                                        onClick={async () => {
                                            try {
                                                const { data } =
                                                    await MyTaskService.checkStatusWorkflow(
                                                        detail?.workflowId
                                                    );
                                                if (data?.resultData) {
                                                    // console.log('go to preview....')
                                                    if (
                                                        data?.resultData
                                                            ?.workFlowIsActive ===
                                                        false
                                                    ) {
                                                        notify({
                                                            type: 'error',
                                                            title: t(
                                                                'MyTask.WorkflowIsDisabled'
                                                            ),
                                                            description: t(
                                                                'MyTask.PleaseContactAdmin',
                                                                {
                                                                    emailOwnerAccount:
                                                                        data
                                                                            ?.resultData
                                                                            ?.emailOwnerAccount,
                                                                }
                                                            ),
                                                            timeOut: 120000,
                                                            closeable: true,
                                                        });
                                                    } else {
                                                        setOpenConfirm(true);
                                                    }
                                                }
                                            } catch (err) {
                                                console.log(err);
                                                notify({
                                                    type: 'error',
                                                    title: t('common.Fail'),
                                                    description:
                                                        t('common.Fail'),
                                                    timeOut: 120000,
                                                    closeable: true,
                                                });
                                            }
                                        }}
                                    >
                                        <CheckOutlined />
                                        {t('MyTask.Accept')}
                                    </Button>
                                </div>
                            ) : (
                                <></>
                            )}

                            {state === 'Complete Task' && isAccept === true ? (
                                <div className="text-right justify-end space-x-2">
                                    <Button
                                        disabled={isAuditor}
                                        className="w-40 border-purple text-purple mb-2 hover:border-purple hover:text-purple hover:opacity-80"
                                        htmlType="submit"
                                        size="large"
                                        type="primary"
                                        icon={<ExportOutlined />}
                                        onClick={() => setActionMode('Extend')}
                                        ghost
                                        hidden={detail?.isExtend}
                                    >
                                        {t('MyTask.Extend')}
                                    </Button>
                                    <Button
                                        disabled={isAuditor}
                                        className="w-40"
                                        htmlType="submit"
                                        size="large"
                                        icon={<CloseOutlined />}
                                        danger
                                        onClick={() => setActionMode('Cancel')}
                                    >
                                        {t('MyTask.CancelTask')}
                                    </Button>
                                    <Button
                                        disabled={isAuditor}
                                        className="w-40 border-[#4ACE8F] bg-[#4ACE8F] text-white hover:bg-[#4ACE8F] hover:border-[#4ACE8F] hover:opacity-80"
                                        htmlType="submit"
                                        size="large"
                                        type="primary"
                                        onClick={() =>
                                            setActionMode('Complete')
                                        }
                                    >
                                        <CheckOutlined />
                                        {t('MyTask.Complete')}
                                    </Button>
                                </div>
                            ) : (
                                <></>
                            )}
                        </>
                    )}

                    {tab === 'cancel-task' &&
                        detail?.operationTask?.map((e) => (
                            <div
                                key={e?.operationTaskId}
                                className="py-1 px-4 bg-[#F5F6FF] my-1 rounded"
                            >
                                <div className="grid grid-cols-12 gap-2">
                                    <div className="col-span-2">
                                        <div className="flex items-center py-2">
                                            <Tag
                                                className="rounded-xl -my-1 text-center w-full"
                                                style={{
                                                    color: _getTagOperationStatus(
                                                        e.statusNameEn
                                                    ).color,
                                                    borderColor:
                                                        _getTagOperationStatus(
                                                            e.statusNameEn
                                                        ).color,
                                                }}
                                            >
                                                {e.statusNameEn}
                                            </Tag>
                                        </div>
                                    </div>
                                    <div className="col-span-2">
                                        <div className="flex items-center text-[12px] font-semibold py-2">
                                            {/* {i18n.language === 'en' ? e?.departmentNameEn || "-" : e?.departmentNameTh || "-"} */}
                                            {e?.departmentList
                                                ?.map((item) =>
                                                    lang === 'en'
                                                        ? item?.departmentNameEn ||
                                                          '-'
                                                        : item.departmentNameTh ||
                                                          '-'
                                                )
                                                .toString()}
                                        </div>
                                    </div>
                                    <div className="col-span-4">
                                        <div className="flex items-center text-[12px] font-semibold space-x-2 py-2">
                                            <span>
                                                {t('MyTask.OperationPerson')} :{' '}
                                            </span>
                                            <span className="font-normal">
                                                {lang === 'en'
                                                    ? e?.assigneeNameEn ||
                                                      'Waiting for a response'
                                                    : e?.assigneeNameTh ||
                                                      'Waiting for a response'}
                                            </span>
                                        </div>
                                    </div>

                                    <div
                                        className="col-span-4 flex items-center justify-end font-semibold text-[12] text-[#F0536F] py-2 "
                                        hidden={
                                            e.statusNameEn !== 'Task Canceled'
                                        }
                                    >
                                        <span className="mr-2">
                                            <ExclamationCircleOutlined />
                                        </span>
                                        {t('MyTask.AcceptCancel')}
                                    </div>
                                    <div
                                        className="col-span-4 flex items-center justify-end space-x-4"
                                        hidden={
                                            e.statusNameEn !== 'Task Canceling'
                                        }
                                    >
                                        <Button
                                            disabled={isAuditor}
                                            className="text-[#7B67FB] border-[#7B67FB] bg-[white] flex items-center justify-center w-[135px] h-[30px] text-[14px]"
                                            type="default"
                                            size="large"
                                            htmlType="submit"
                                            onClick={async () => {
                                                setActionMode('Reassigned');
                                                setCancelDetail(e);
                                            }}
                                        >
                                            {t('MyTask.Reassigned')}
                                        </Button>
                                        <Button
                                            disabled={isAuditor}
                                            className="flex items-center justify-center w-[135px] h-[30px] text-[14px]"
                                            size="large"
                                            type="primary"
                                            onClick={async () => {
                                                try {
                                                    const { data } =
                                                        await MyTaskService.checkStatusWorkflow(
                                                            detail?.workflowId
                                                        );
                                                    if (data?.resultData) {
                                                        if (
                                                            data?.resultData
                                                                ?.workFlowIsActive ===
                                                            false
                                                        ) {
                                                            notify({
                                                                type: 'error',
                                                                title: t(
                                                                    'MyTask.WorkflowIsDisabled'
                                                                ),
                                                                description: t(
                                                                    'MyTask.PleaseContactAdmin',
                                                                    {
                                                                        emailOwnerAccount:
                                                                            data
                                                                                ?.resultData
                                                                                ?.emailOwnerAccount,
                                                                    }
                                                                ),
                                                                timeOut: 120000,
                                                                closeable: true,
                                                            });
                                                        } else {
                                                            setOpenConfirmAcknowledge(
                                                                true
                                                            );
                                                            setCancelDetail(e);
                                                        }
                                                    }
                                                } catch (err) {
                                                    console.log(err);
                                                    notify({
                                                        type: 'error',
                                                        title: t('common.Fail'),
                                                        description:
                                                            t('common.Fail'),
                                                        timeOut: 120000,
                                                        closeable: true,
                                                    });
                                                }
                                            }}
                                        >
                                            {t('MyTask.Acknowledge')}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        ))}

                    {/* follow-up */}
                    {/* follow-up */}
                    {/* follow-up */}
                    {/* follow-up */}
                    {/* follow-up */}
                    {/* follow-up */}
                    {/* follow-up */}
                    {tab === 'follow-up' && (
                        <>
                            <div
                                className="my-4"
                                style={{ borderBottom: '1px solid #ECECEC' }}
                            ></div>
                            {(state === 'Assign Task' ||
                                state === 'Other Task') &&
                                detail?.operationTask?.map((e) => (
                                    <div
                                        key={e?.operationTaskId}
                                        className="py-1 px-4 bg-[#F5F6FF] my-1 rounded "
                                    >
                                        <div className="grid grid-cols-12 gap-2">
                                            <div className="col-span-4">
                                                <div className=" flex items-center text-[12px] font-semibold py-2">
                                                    {/* {lang === 'en' ? e?.departmentNameEn || "-" : e.departmentNameTh || '-'} */}
                                                    {e?.departmentList
                                                        ?.map((item) =>
                                                            lang === 'en'
                                                                ? item?.departmentNameEn ||
                                                                  '-'
                                                                : item.departmentNameTh ||
                                                                  '-'
                                                        )
                                                        .toString()}
                                                </div>
                                            </div>
                                            <div className="col-span-4">
                                                <div className="flex items-center text-[12px] font-semibold space-x-2 py-2">
                                                    <span>
                                                        {t(
                                                            'MyTask.OperationPerson'
                                                        )}{' '}
                                                        :{' '}
                                                    </span>
                                                    <span className="font-normal">
                                                        {lang === 'en'
                                                            ? e?.assigneeNameEn ||
                                                              'Waiting for a response'
                                                            : e?.assigneeNameTh ||
                                                              'Waiting for a response'}
                                                    </span>
                                                </div>
                                            </div>
                                            <div
                                                className="col-span-4"
                                                hidden={
                                                    e?.statusNameEn ===
                                                        'Task Canceled' ||
                                                    e?.statusNameEn ===
                                                        'Task Done'
                                                }
                                            >
                                                <div className="flex items-center justify-end">
                                                    <CountdownRemind
                                                        e={e}
                                                        setActionMode={
                                                            setActionMode
                                                        }
                                                        setRemindDetail={
                                                            setRemindDetail
                                                        }
                                                        targetDate={
                                                            e?.remindDateTime
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                            {state === 'Complete Task' &&
                                detail?.operationTask?.map((e) => (
                                    <div
                                        key={e?.operationTaskId}
                                        className="py-1 px-4 bg-[#F5F6FF] my-1 rounded "
                                    >
                                        <div className="grid grid-cols-12 gap-2">
                                            <div className="col-span-2">
                                                <div className="flex items-center py-2">
                                                    <Tag
                                                        className="rounded-xl -my-1 text-center w-full"
                                                        style={{
                                                            color: _getTagOperationStatus(
                                                                e?.statusNameEn
                                                            ).color,
                                                            borderColor:
                                                                _getTagOperationStatus(
                                                                    e?.statusNameEn
                                                                ).color,
                                                        }}
                                                    >
                                                        {e?.statusNameEn}
                                                    </Tag>
                                                </div>
                                            </div>
                                            <div className="col-span-2">
                                                <div className="flex items-center text-[12px] font-semibold py-2">
                                                    {/* {lang === 'en' ? e?.departmentNameEn || "-" : e.departmentNameTh || '-'} */}
                                                    {e?.departmentList?.map(
                                                        (item) =>
                                                            lang === 'en'
                                                                ? item?.departmentNameEn ||
                                                                  '-'
                                                                : item.departmentNameTh ||
                                                                  '-'
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-span-4">
                                                <div className="flex items-center text-[12px] font-semibold space-x-2 py-2">
                                                    <span>
                                                        {t(
                                                            'MyTask.OperationPerson'
                                                        )}{' '}
                                                        :{' '}
                                                    </span>
                                                    <span className="font-normal">
                                                        {lang === 'en'
                                                            ? e?.assigneeNameEn ||
                                                              'Waiting for a response'
                                                            : e?.assigneeNameTh ||
                                                              'Waiting for a response'}
                                                    </span>
                                                </div>
                                            </div>
                                            <div
                                                className="col-span-4"
                                                hidden={
                                                    e?.statusNameEn ===
                                                        'Task Canceled' ||
                                                    e?.statusNameEn ===
                                                        'Task Done'
                                                }
                                            >
                                                <div className="flex items-center justify-end">
                                                    <CountdownRemind
                                                        t={t}
                                                        e={e}
                                                        setActionMode={
                                                            setActionMode
                                                        }
                                                        setRemindDetail={
                                                            setRemindDetail
                                                        }
                                                        targetDate={
                                                            e?.remindDateTime
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                        </>
                    )}

                    {/* operation-done */}
                    {/* operation-done */}
                    {/* operation-done */}
                    {/* operation-done */}
                    {/* operation-done */}
                    {/* operation-done */}
                    {/* operation-done */}
                    {tab === 'operation-done' && (
                        <>
                            <div
                                className="my-4"
                                style={{ borderBottom: '1px solid #ECECEC' }}
                            ></div>
                            {detail?.operationTask?.map((e) => (
                                <div
                                    key={e?.operationTaskId}
                                    className="py-1 px-4 bg-[#F5F6FF] my-1 rounded"
                                >
                                    <div className="grid grid-cols-12 gap-2">
                                        <div className="col-span-2">
                                            <div className="flex items-center py-2">
                                                <Tag
                                                    className="rounded-xl -my-1 text-center w-full"
                                                    style={{
                                                        color: _getTagOperationStatus(
                                                            e.statusNameEn
                                                        ).color,
                                                        borderColor:
                                                            _getTagOperationStatus(
                                                                e.statusNameEn
                                                            ).color,
                                                    }}
                                                >
                                                    {e.statusNameEn}
                                                </Tag>
                                            </div>
                                        </div>
                                        <div className="col-span-2 flex items-center text-[12px] font-semibold py-2">
                                            {e?.departmentList?.map((item) =>
                                                lang === 'en'
                                                    ? item?.departmentNameEn ||
                                                      '-'
                                                    : item.departmentNameTh ||
                                                      '-'
                                            )}
                                        </div>
                                        <div className="col-span-4 flex items-center text-[12px] font-semibold space-x-2 py-2">
                                            <span>
                                                {t('MyTask.OperationPerson')} :{' '}
                                            </span>
                                            <span className="font-normal">
                                                {lang === 'en'
                                                    ? e?.assigneeNameEn ||
                                                      'Waiting for a response'
                                                    : e?.assigneeNameTh ||
                                                      'Waiting for a response'}
                                            </span>
                                        </div>

                                        <div
                                            className="col-span-4 flex items-center justify-end font-semibold text-[12] text-[#F0536F] py-2 "
                                            hidden={
                                                e.statusNameEn !==
                                                'Task Canceled'
                                            }
                                        >
                                            <span className="mr-2">
                                                <ExclamationCircleOutlined />
                                            </span>
                                            {t('MyTask.AcceptCancel')}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </>
                    )}

                    {/* request-done */}
                    {/* request-done */}
                    {/* request-done */}
                    {/* request-done */}
                    {/* request-done */}
                    {/* request-done */}
                    {/* request-done */}
                    {tab === 'request-done' && (
                        <>
                            <div
                                className="my-4"
                                style={{ borderBottom: '1px solid #ECECEC' }}
                            ></div>
                            {requestStatus === 'Reject' && (
                                <div className="font-semibold text-[14px]">
                                    {t('MyTask.ReasonReject')} :{' '}
                                    <span className="font-normal text-[14px]">
                                        {detail?.reasonReject || '-'}
                                    </span>
                                </div>
                            )}
                            {requestStatus !== 'Reject' &&
                                detail?.operationTask?.map((e) => (
                                    <div
                                        key={e?.operationTaskId}
                                        className="py-1 px-4 bg-[#F5F6FF] my-1 rounded"
                                    >
                                        <div className="grid grid-cols-12 gap-2">
                                            <div className="col-span-2">
                                                <div className="flex items-center py-2">
                                                    <Tag
                                                        className="rounded-xl -my-1 text-center w-full"
                                                        style={{
                                                            color: _getTagOperationStatus(
                                                                e.statusNameEn
                                                            ).color,
                                                            borderColor:
                                                                _getTagOperationStatus(
                                                                    e.statusNameEn
                                                                ).color,
                                                            width: 110,
                                                        }}
                                                    >
                                                        {e.statusNameEn}
                                                    </Tag>
                                                </div>
                                            </div>
                                            <div className="col-span-2">
                                                <div className="flex items-center text-[12px] font-semibold py-2">
                                                    {e?.departmentList?.map(
                                                        (item) =>
                                                            lang === 'en'
                                                                ? item?.departmentNameEn ||
                                                                  '-'
                                                                : item.departmentNameTh ||
                                                                  '-'
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-span-4">
                                                <div className="flex items-center text-[12px] font-semibold space-x-2 py-2">
                                                    <span>
                                                        {t(
                                                            'MyTask.OperationPerson'
                                                        )}
                                                        :{' '}
                                                    </span>
                                                    <span className="font-normal">
                                                        {lang === 'en'
                                                            ? e?.assigneeNameEn ||
                                                              'Waiting for a response'
                                                            : e?.assigneeNameTh ||
                                                              'Waiting for a response'}
                                                    </span>
                                                </div>
                                            </div>

                                            <div
                                                className="col-span-4"
                                                hidden={
                                                    e.statusNameEn !==
                                                    'Task Canceled'
                                                }
                                            >
                                                <div className="flex items-center justify-end font-semibold text-[12] text-[#F0536F] py-2">
                                                    <span className="mr-2">
                                                        <ExclamationCircleOutlined />
                                                    </span>
                                                    {t('MyTask.AcceptCancel')}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                        </>
                    )}
                </div>
            </Form>
            <ModalConfirm
                title={t('common.ConfirmProcess')}
                text={t('MyTask.DoYouWantAcceptData')}
                loading={loading}
                open={openConfirm}
                handelOk={() => {
                    accectMyTask();
                    // setIsAccept(true);
                }}
                handelClose={() => {
                    setOpenConfirm(false);
                    // setIsAccept(false);
                }}
            />
            <ModalConfirm
                title={t('MyTask.ConfirmAcknowledge')}
                text={t('MyTask.WhenYouPressConfirm')}
                loading={loading}
                open={openConfirmAcknowledge}
                handelOk={() => {
                    confirmAcknowledge();
                }}
                handelClose={() => {
                    setOpenConfirmAcknowledge(false);
                }}
            />
        </>
    );
}

const CountdownRemind = ({ targetDate, setActionMode, setRemindDetail, e }) => {
    const { t } = useTranslation();

    const [minutes, seconds] = useCountdown(targetDate);
    const timer = minutes * 60 + seconds;

    if (timer <= 0) {
        return (
            <Button
                // hidden={checkDate('2022-11-22T13:01:59.831Z') || isRemind === 'true'}
                className="flex items-center justify-center w-[140px] h-[30px] text-[14px]"
                htmlType="submit"
                size="large"
                type="primary"
                onClick={() => {
                    setActionMode('Remind');
                    setRemindDetail(e);
                }}
            >
                {t('MyTask.Remind')}
            </Button>
        );
    } else {
        return (
            <div className="flex items-center justify-center w-[140px] h-[30px] text-[14px] text-[#7B67FB] bg-[#D9D3FF] rounded-md">
                {`${timer} ${t('MyTask.Second')}`}
            </div>
        );
    }
};
